import "./index.css";

import { alpha,Box, Typography, useTheme } from "@mui/material";
import { MatchStatus } from "@virtualprogaming/js-public-sdk";
import { map, max, take } from "lodash-es";
import React from "react";
import { useHistory } from "react-router-dom";

import { useLeagueMatchesByStatusPaged, useLeagueSeasons } from "~/queries";
import { CDNImage, ImageVariant } from "~/ui/components";

export const HeaderAnnouncements: React.FC = () => {
  const theme = useTheme();
  const { data: seasons } = useLeagueSeasons("Esports-Premier-PS5");

  const { data: matches } = useLeagueMatchesByStatusPaged(
    "Esports-Premier-PS5",
    MatchStatus.Complete,
    max(seasons),
    undefined,
    undefined,
    undefined,
    undefined,
    { keepPreviousData: true }
  );

  const { push } = useHistory();

  return (
    <Box
      className="nav-announcement"
      sx={{
        display: "flex",
        alignItems: "center",
        background: `linear-gradient(145deg, rgba(26,26,26,0.95) 0%, rgba(35,35,35,0.95) 100%)`,
        backdropFilter: "blur(10px)",
        border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        borderRadius: "0px",
        overflow: "hidden",
        position: "relative",
        px: 2,
        py: 0,
        minHeight: "3.5rem",
        boxShadow: `0 2px 8px ${alpha("#000", 0.18)}`,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2px",
          background: `linear-gradient(90deg, ${
            theme.palette.primary.main
          }, ${alpha(theme.palette.primary.main, 0.3)})`,
        },
      }}
    >
      <Box
        className="scroll-container"
        sx={{ width: "100%", overflow: "hidden" }}
      >
        <Box
          className="scroll-text"
          sx={{
            display: "flex",
            gap: 4,
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          {map(take(matches?.data, 10), (match) => (
            <Box
              key={match.id}
              onClick={() => push(`/match/${match.id}`)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                px: 3,
                py: 1,
                borderRadius: "6px",
                background: alpha(theme.palette.primary.main, 0.04),
                cursor: "pointer",
                transition: "background 0.2s, box-shadow 0.2s, transform 0.2s",
                boxShadow: "none",
                "&:hover": {
                  background: alpha(theme.palette.primary.main, 0.1),
                  boxShadow: `0 4px 16px ${alpha(
                    theme.palette.primary.main,
                    0.1
                  )}`,
                  transform: "translateY(-2px) scale(1.03)",
                },
              }}
              className="pointer"
            >
              <CDNImage
                imageId={match.home_logo}
                variant={ImageVariant.SmallThumbnail}
                alt="home"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 4,
                  boxShadow: `0 2px 8px ${alpha(
                    theme.palette.primary.main,
                    0.08
                  )}`,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  letterSpacing: "0.02em",
                  minWidth: 60,
                  textAlign: "right",
                  textShadow: `0 1px 4px ${alpha("#000", 0.4)}`,
                  whiteSpace: "nowrap",
                }}
              >
                {match.home_name}
              </Typography>
              <Box
                sx={{
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "6px",
                  background: alpha(theme.palette.background.paper, 0.7),
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontWeight: 700,
                  fontSize: "1rem",
                  color: theme.palette.primary.main,
                  boxShadow: `0 1px 4px ${alpha(
                    theme.palette.primary.main,
                    0.08
                  )}`,
                  border: `1px solid ${alpha(
                    theme.palette.primary.main,
                    0.18
                  )}`,
                }}
              >
                <span>{match.home_score}</span>
                <span>-</span>
                <span>{match.away_score}</span>
              </Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  letterSpacing: "0.02em",
                  minWidth: 60,
                  textAlign: "left",
                  textShadow: `0 1px 4px ${alpha("#000", 0.4)}`,
                  whiteSpace: "nowrap",
                }}
              >
                {match.away_name}
              </Typography>
              <CDNImage
                imageId={match.away_logo}
                variant={ImageVariant.SmallThumbnail}
                alt="away"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 4,
                  boxShadow: `0 2px 8px ${alpha(
                    theme.palette.primary.main,
                    0.08
                  )}`,
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
